var parseTimeRanges = function (ranges) {
    var result = [];
    for (var i = 0; i < ranges.length; i++) {
        result.push({
            start: ranges.start(i),
            end: ranges.end(i),
        });
    }
    return result;
};
export default parseTimeRanges;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/util/parseTimeRanges.js
// module id = 88lr
// module chunks = 0